import React, { useCallback } from "react";
import { useEffect, useState } from "react";

import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { Modal, Button } from "react-bootstrap";
import { FaUserEdit } from 'react-icons/fa';
import { Link, useNavigate } from "react-router-dom";

import "./ClassOverview.css";
import { formatAcademicYear, getAcademicYear } from "../utils/academicYear";

import AssessmentStatus from "./AssessmentStatus";
import ShareClassButton from "./ShareClassButton";
import AddStudentsButton from "./AddStudentsButton";
import ClassPersonnel from "./ClassPersonnel";
import ClassStudents from "./ClassStudents";
import SimpleNavigatioButton from "./SimpleNavigationButton";
import GradeCard from "./GradeCard";
import ClassSettingsButton from "./ClassSettingsButton";
import ViewQRLogins from "./ViewQRLogins";
import StudentManagementModal from "./StudentManagementModal";
import NoteModal from "./NoteModal";

import { getClassAssessments, getStudents, getCountryId, getNotes } from "../services/APIClient";

function ClassOverview(props) {
  // Class Personnel
  let group = props.group;
  let classDetails = props.classDetails;
  let classid = classDetails.id;
  let gradeLevel = props.gradeLevel;
  let name = props.name;
  let teachers = props.teachers;
  let sharedWith = props.sharedWith;
  let students = props.students;
  let qrCodeDetails = props.qrCodeDetails;
  let dateCreated = classDetails.date_created;
  let yearCreated = dateCreated.slice(0, 4);
  let gradeLevel1 = classDetails.grade_level1;
  let gradeLevel2 = classDetails.grade_level2;
  let gradeLevel3 = classDetails.grade_level3;
  let trialClass = classDetails.trial_class;
  let rollNumber = props.rollNumber;
  let teacherEmail = props.teacherEmail;
  let schoolid = props.schoolid;
  let isSpecialEdClass = props.isSpecialEdClass;
  let teacherRoles = props?.teacherRoles;
  let teacherid = props.teacherid;
  let teacherName = props.teacherName;
  let isAccessRestricted = props.isAccessRestricted;
  let isPilot = props.isPilot;
  let isSnapshot = classDetails.snapshot;
  let isFromClassSelection = props.isFromClassSelection;
  // let fromClassDetailsSpecial = false;
  let fromClassDetailsSpecial = props.fromClassDetailsSpecial;

  console.log(teacherid, "TEACHER ID IN CLASS OVERVIEW");
  console.log(name, "NAME IN CLASS OVERVIEW");
  console.log(teacherName, "teacherName IN CLASS OVERVIEW");

  const [classAssessments, setClassAssessments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentStudents, setCurrentStudents] = useState(students || []);
  const [countryId, setCountryId] = useState(null);

  // State for modals
  const [showTrialEndedModal, setShowTrialEndedModal] = useState(false);
  const [showStudentManagementFlow, setShowStudentManagementFlow] = useState(false);
  const [showFinalConfirmationModal, setShowFinalConfirmationModal] = useState(false);


  const classAssessmentsValues = Object.values(classAssessments);

  // Fetch class assessments
  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    getClassAssessments(classid)
      .then((response) => {
        if (isMounted) setClassAssessments(response);
      })
      .catch((error) => console.error("Failed to fetch assessments:", error))
      .finally(() => {
        if (isMounted) setLoading(false);
      });
    return () => {
      isMounted = false;
    };
  }, [classid]);

  // Fetch country ID based on school
  useEffect(() => {
    if (schoolid) {
      getCountryId(schoolid)
        .then((response) => {
          if (response.countryId) {
            console.log(response)
            setCountryId(response.countryId);
          } else {
            console.warn("No country ID found for school:", response.message);
            // Optionally set a default or leave as null
            setCountryId(null);
          }
        })
        .catch((error) => {
          console.error("Failed to fetch country ID:", error);
          // Optionally set a default value on error
          setCountryId(null);
        });
    }
  }, [schoolid]);

  // Refresh students data when needed
  const refreshStudents = useCallback(async () => {
    try {
      const response = await getStudents(classid);
      const allStudents = [
        ...(response.students || []),
        ...(response.additionalStudents || []),
      ];
      setCurrentStudents(allStudents);
    } catch (error) {
      console.error("Failed to refresh students:", error);
    }
  }, [classid]);


  // Show student management flow when coming from class selection
  useEffect(() => {
    if (isFromClassSelection) {
      if (fromClassDetailsSpecial) {
        // Bypass StudentManagementModal and go directly to final confirmation
        setShowFinalConfirmationModal(true);
      } else {
        // Show StudentManagementModal as normal
        setShowStudentManagementFlow(true);
      }
    }
  }, [isFromClassSelection, fromClassDetailsSpecial]);

  const handleTrialEndedModal = () => setShowTrialEndedModal(true);
  const handleModalClose = () => setShowTrialEndedModal(false);

  // Handle closing the student management flow
  const handleCloseStudentManagementFlow = () => {
    setShowStudentManagementFlow(false);
  };

  const getSchoolYear = (dateCreated) => {
    try {
      return `${formatAcademicYear(getAcademicYear(dateCreated), "fullDisplay")} School Year`;
    } catch (error) {
      return "Unknown School Year";
    }
  };

  const handleShowFinalConfirmation = (isFromSpecial) => {
    setShowFinalConfirmationModal(true);
    // Store the fromSpecial flag if you need it, or just use the existing prop
  };

  const handleCloseFinalConfirmation = () => {
    setShowFinalConfirmationModal(false);
    refreshStudents(); // optional re-sync
  };

  const handlePrintAllNotes = async () => {
    const formatNote = (n, teachersList) => {
      const teacher = teachersList.find((t) => t.id === n.teacherid);
      const teacherName = teacher?.name || 'Unknown';
      const dateStr = new Date(n.date_created).toLocaleString('en-IE', {
        day: 'numeric', month: 'short', year: 'numeric',
        hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'Europe/Dublin',
      });
      return `
        <div style="margin-bottom:12px; padding:10px 12px; border-left:3px solid #1a56db; background:#f8f9fa; border-radius:4px;">
          <div style="display:flex; justify-content:space-between; align-items:center; margin-bottom:6px;">
            <span style="font-size:11px; color:#666;">${teacherName} &bull; ${dateStr}</span>
          </div>
          <div style="font-size:13px; color:#333; white-space:pre-wrap;">${n.note_text}</div>
        </div>`;
    };

    // MOVING OUT FROM ABOVE AND ADDING TO BELOW TO REMOVE NOTE TYPE FROM PRINTED NOTES
    // <span style="font-size:11px; font-weight:bold; background:#1a56db; color:white; padding:2px 8px; border-radius:4px;">${n.note_type}</span>

    const [classNotesRes, ...studentNotesRes] = await Promise.all([
      getNotes('class', classid, 'ClassOverview'),
      ...currentStudents.map((s) => getNotes('student', s.id, 'ClassOverview').then((r) => ({ name: s.name, notes: r.data || [] }))),
    ]);

    const classNotes = classNotesRes.data || [];
    const studentsWithNotes = studentNotesRes.filter((s) => s.notes.length > 0);

    let html = `
      <!DOCTYPE html>
      <html>
      <head><title>All Notes — ${name}</title></head>
      <body style="font-family: Arial, sans-serif; padding: 32px; max-width: 760px; margin: 0 auto; color: #1f2937;">
        <h1 style="border-bottom: 2px solid #1a56db; padding-bottom: 8px; color: #1a56db; margin-bottom: 4px;">${name} — All Notes</h1>
        <p style="color: #999; font-size: 11px; margin-bottom: 28px;">Printed: ${new Date().toLocaleString('en-IE', { timeZone: 'Europe/Dublin' })}</p>`;

    if (classNotes.length > 0) {
      html += `<h2 style="color:#333; margin-top:0; margin-bottom:12px;">Class Notes</h2>`;
      html += classNotes.map((n) => formatNote(n, teachers)).join('');
    }

    if (studentsWithNotes.length > 0) {
      html += `<h2 style="color:#333; margin-top:28px; margin-bottom:12px;">Student Notes</h2>`;
      studentsWithNotes.forEach((section) => {
        html += `<h3 style="margin-top:16px; margin-bottom:8px; color:#444;">${section.name}</h3>`;
        html += section.notes.map((n) => formatNote(n, teachers)).join('');
      });
    }

    if (classNotes.length === 0 && studentsWithNotes.length === 0) {
      html += `<p style="color:#999; text-align:center; margin-top:48px;">No notes found for this class.</p>`;
    }

    html += '</body></html>';

    const printWindow = window.open('', '_blank', 'width=800,height=600');
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    setTimeout(() => { printWindow.print(); printWindow.close(); }, 250);
  };


  return (
    <div className="class-overview-container">
      <Container className="container-shape">
        <Row className="page-description-bar">
          <Col className="col-7">
            <Row className="inline-block">
              <Col className="col-6">
                <h1 className="page-description-header">
                  {group.name} {isSnapshot && "(Snapshot)"}
                </h1>
                {/* <h4 className="year-header">{getSchoolYear(dateCreated)}</h4> */}
              </Col>
              <Col className="col-3">
                <GradeCard
                  gradeLevel={classDetails.grade_level}
                  gradeLevel1={gradeLevel1}
                  gradeLevel2={gradeLevel2}
                  gradeLevel3={gradeLevel3}
                  trialClass={trialClass}
                />{" "}
              </Col>
              {/* {!isSnapshot && (
                <Col className="col-1" style={{ display: 'flex', alignItems: 'center' }}>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    border: '2px solid #1a56db',
                    borderRadius: '8px',
                    padding: '4px 8px',
                    backgroundColor: '#eef2ff',
                    gap: '2px',
                  }}>
                    <NoteModal
                      entityName={name}
                      elementtype="class"
                      elementid={classid}
                      noteType="Admin"
                      teacherid={teacherid}
                      teachers={teachers || []}
                    />
                    <span style={{ fontSize: '10px', color: '#1a56db', fontWeight: '600', lineHeight: 1 }}>Notes</span>
                  </div>
                </Col>
              )} */}
              {!isSnapshot && (
                <Col className="col-1">
                  <ClassSettingsButton
                    group={group}
                    classDetails={classDetails}
                    teachers={teachers}
                    sharedWith={sharedWith}
                    gradeLevel={gradeLevel}
                    name={name}
                    students={students}
                    qrCodeDetails={qrCodeDetails}
                    teacherRoles={teacherRoles}
                  />
                </Col>
              )}
            </Row>
            <p className="paragraph-font-size">
              {isSnapshot
                ? "This is a snapshot view of the class data. Interactive features are disabled."
                : ""
              }
            </p>
          </Col>
          <Col className="col-1"></Col>
          <Col className="col-4">
            <Row>
              {/* <Col className="col-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                {!isSnapshot && (
                  <button
                    onClick={handlePrintAllNotes}
                    style={{
                      background: 'none',
                      border: '2px solid #1a56db',
                      borderRadius: '8px',
                      color: '#1a56db',
                      fontSize: '12px',
                      fontWeight: '600',
                      padding: '4px 10px',
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Print All Notes
                  </button>
                )}
              </Col> */}
              <Col className="col-6">
                <SimpleNavigatioButton
                  path="/classadmindashboard"
                  label="Back"
                  colour="blue"
                />
              </Col>
            </Row>
            {!isSnapshot && (
              <Row>
                <Col>
                  <div style={{
                    backgroundColor: '#cc5182ff',
                    border: '2px solid #f43782ff',
                    borderRadius: '12px',
                    padding: '10px',
                    textAlign: 'center',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    fontSize: '90%',
                    fontWeight: '600',
                    color: '#ffffffff',
                    margin: '0 auto',
                    marginTop: '5%',
                    marginTLeft: '5%',
                    // maxWidth: '100%'
                  }}>
                    To delete classrooms, please email details to <br></br><strong className="email-highlight">info@alpaca-assessment.com</strong>
                  </div>
                </Col>
              </Row>
            )}

          </Col>
        </Row>
        <hr />
        <Row>
          <Row className="centre-buttons-classoverview">
            <Col className="col-3">
              {!isSnapshot && (
                isAccessRestricted ? (
                  <div
                    className="disabled-card-wrapper"
                    onClick={handleTrialEndedModal}
                  >
                    <AddStudentsButton
                      classDetails={classDetails}
                      teachers={teachers}
                      sharedWith={sharedWith}
                      name={name}
                      gradeLevel={gradeLevel}
                      schoolid={schoolid}
                      isSpecialEdClass={isSpecialEdClass}
                      teacherid={teacherid}
                    />
                  </div>
                ) : (
                  <AddStudentsButton
                    classDetails={classDetails}
                    teachers={teachers}
                    sharedWith={sharedWith}
                    name={name}
                    gradeLevel={gradeLevel}
                    schoolid={schoolid}
                    isSpecialEdClass={isSpecialEdClass}
                    teacherid={teacherid}
                  />
                )
              )}
            </Col>
            <Col className="col-3">
              {!isSnapshot && (
                isAccessRestricted ? (
                  <div
                    className="disabled-card-wrapper"
                    onClick={handleTrialEndedModal}
                  >
                    <button
                      className="light-blue-button add-pupils-button"
                    // style={{ opacity: '0.6', pointerEvents: 'none' }}
                    >
                      Edit/Remove Students <br></br><FaUserEdit size={58} />
                    </button>
                  </div>
                ) : (
                  <button
                    className="light-blue-button add-pupils-button"
                    onClick={() => setShowStudentManagementFlow(true)}
                  >
                    Edit/Remove Students <br></br><FaUserEdit size={58} />
                  </button>
                )
              )}
            </Col>
            <Col className="col-3">
              {!isSnapshot && (
                <ViewQRLogins
                  name={name}
                  label="View/Print QR Codes"
                  gradeLevel={gradeLevel}
                  qrCodeDetails={qrCodeDetails}
                />
              )}
            </Col>
            <Col className="col-3">
              {!isSnapshot && (
                <ShareClassButton
                  classDetails={classDetails}
                  teachers={teachers}
                  sharedWith={sharedWith}
                  name={name}
                  gradeLevel={gradeLevel}
                  rollNumber={rollNumber}
                  teacherEmail={teacherEmail}
                  schoolid={schoolid}
                />
              )}
            </Col>
            {/* <Col className="col-3">
              {!isSnapshot && (
                expired && !purchased_2526 ? (
                  <div
                    className="disabled-card-wrapper"
                    onClick={handleTrialEndedModal}
                  >
                    <AddStudentsButton
                      classDetails={classDetails}
                      teachers={teachers}
                      sharedWith={sharedWith}
                      name={name}
                      gradeLevel={gradeLevel}
                      schoolid={schoolid}
                      isSpecialEdClass={isSpecialEdClass}
                      teacherid={teacherid}
                    />
                  </div>
                ) : (
                  <AddStudentsButton
                    classDetails={classDetails}
                    teachers={teachers}
                    sharedWith={sharedWith}
                    name={name}
                    gradeLevel={gradeLevel}
                    schoolid={schoolid}
                    isSpecialEdClass={isSpecialEdClass}
                    teacherid={teacherid}
                  />
                )
              )}
            </Col> */}
          </Row>
          <br></br>
          <Row>
            <Col className="col-7">
              <ClassStudents
                students={currentStudents}
                classDetails={classDetails}
                teachers={teachers}
                qrCodeDetails={qrCodeDetails}
                schoolid={schoolid}
                teacherRoles={teacherRoles}
                teacherid={teacherid}
                isSnapshot={isSnapshot}
              />
            </Col>
            <Col className="col-5 right-side-container">
              <ClassPersonnel
                classOwnerId={group.classOwnerId}
                classDetails={classDetails}
                teachers={teachers}
                sharedWith={sharedWith}
              />
              <br></br>
            </Col>
          </Row>
        </Row>
      </Container>

      {/* Trial Ended Modal */}
      <Modal show={showTrialEndedModal} onHide={handleModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Trial Ended</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your trial period has ended. To continue using ALPACA's features,
          please proceed with a purchase.
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => setShowTrialEndedModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <StudentManagementModal
        show={showStudentManagementFlow}
        onClose={handleCloseStudentManagementFlow}
        students={currentStudents}
        classid={classid}
        teacherid={teacherid}
        teacherName={teacherName}
        countryId={countryId}
        gradeLevel={gradeLevel}
        name={name}
        onRefreshStudents={refreshStudents}
        fromClassDetailsSpecial={fromClassDetailsSpecial}
        onShowConfirmation={handleShowFinalConfirmation}  // NEW PROP
        teachers={teachers || []}
      />

      <Modal show={showFinalConfirmationModal} onHide={handleCloseFinalConfirmation} centered size="md">
        <Modal.Header closeButton>
          <Modal.Title>All Set!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{
            textAlign: 'center',
            padding: '32px 16px'
          }}>
            <div style={{
              fontSize: '64px',
              marginBottom: '24px',
              color: '#10b981'
            }}>
              ✅
            </div>

            <h4 style={{
              fontSize: '20px',
              fontWeight: '600',
              color: '#1f2937',
              marginBottom: '16px'
            }}>
              {fromClassDetailsSpecial
                ? "The classroom is ready. Next assign a screener, print QRs and watch the 'before screening' videos with children in class before screening "
                : "The classroom is ready. Next assign a screener, print QRs and watch the 'before screening' videos with children in class before screening "
              }
            </h4>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ justifyContent: 'center' }}>
          <Link to="/beforescreening">
            <Button
              variant="primary"
              onClick={handleCloseFinalConfirmation}
              style={{
                padding: '12px 24px',
                fontSize: '16px',
                fontWeight: '500',
                minWidth: '120px'
              }}
            >
              Got it!
            </Button>
          </Link>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ClassOverview;
